import { render, staticRenderFns } from "./WorkspaceGeneSetProvenancePanel.vue?vue&type=template&id=7a4780f0&scoped=true"
import script from "./WorkspaceGeneSetProvenancePanel.vue?vue&type=script&lang=js"
export * from "./WorkspaceGeneSetProvenancePanel.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceGeneSetProvenancePanel.vue?vue&type=style&index=0&id=7a4780f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4780f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a4780f0')) {
      api.createRecord('7a4780f0', component.options)
    } else {
      api.reload('7a4780f0', component.options)
    }
    module.hot.accept("./WorkspaceGeneSetProvenancePanel.vue?vue&type=template&id=7a4780f0&scoped=true", function () {
      api.rerender('7a4780f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceGeneSetProvenancePanel.vue"
export default component.exports